import React from 'react';
import { Loader2, RefreshCw, BadgeDollarSign, BadgeCheck, BadgeX, BadgeHelp } from 'lucide-react';
import { situacao, fmtDataHora } from './CreditoResultado';

// Selo compacto para tabelas/listas (só aparece quando há resultado da Claro)
export const CreditoVendaBadge = ({ credito, testid }) => {
  if (!credito || credito.status !== 'ok') return null;
  const s = situacao(credito.resultado, credito.mensagem);
  const cls = s.tom === 'verde' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300'
    : s.tom === 'vermelho' ? 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300' : 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300';
  return (
    <span className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-bold uppercase ${cls}`} title={credito.mensagem || ''} data-testid={testid}>
      <s.Icone className="w-3 h-3" /> Crédito {(s.curto || s.label).toLowerCase()}
    </span>
  );
};

// Card no Detalhar da venda (mesmo padrão do Lei Não Perturbe)
export const CreditoVendaResumo = ({ credito, onReconsultar, carregando }) => {
  const ok = credito?.status === 'ok';
  const s = ok ? situacao(credito.resultado, credito.mensagem) : null;
  const cor = !credito ? 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50'
    : !ok ? 'border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20'
      : s.tom === 'verde' ? 'border-emerald-300 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/20'
        : s.tom === 'vermelho' ? 'border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20' : 'border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20';
  const Icone = !credito ? BadgeDollarSign : !ok ? BadgeHelp : s.tom === 'verde' ? BadgeCheck : s.tom === 'vermelho' ? BadgeX : BadgeHelp;
  const corIcone = !credito ? 'text-gray-500' : !ok ? 'text-amber-600' : s.tom === 'verde' ? 'text-emerald-600' : s.tom === 'vermelho' ? 'text-red-600' : 'text-amber-600';
  const titulo = !credito ? 'Crédito Claro: ainda não consultado'
    : !ok ? `Crédito Claro: ${credito.mensagem || 'não foi possível consultar'}`
      : `Crédito Claro: ${s.label}`;
  return (
    <div className={`rounded-lg border px-3 py-2 ${cor}`} data-testid="credito-venda-resumo">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <Icone className={`w-4 h-4 shrink-0 ${corIcone}`} />
          <div className="min-w-0">
            <p className={`text-sm font-semibold ${ok && s.tom === 'vermelho' ? 'text-red-700 dark:text-red-300' : ''}`} data-testid="credito-venda-titulo">{titulo}</p>
            {ok && credito.mensagem && <p className="text-xs font-medium" data-testid="credito-venda-mensagem">{credito.mensagem}</p>}
            {ok && s.n2 && (
              <p className="text-[11px] font-semibold text-red-700 dark:text-red-300" data-testid="credito-venda-n2">
                {credito.cancelada_em ? `Venda cancelada automaticamente em ${fmtDataHora(credito.cancelada_em)} — a Claro não libera produto (análise N2 / fatura da concorrência).` : 'A Claro não libera produto para este cliente (análise N2 / fatura da concorrência) — cancelamento automático.'}
              </p>
            )}
            {credito?.consultado_em && (
              <p className="text-[11px] text-gray-500">
                Consultado em {fmtDataHora(credito.consultado_em)}{credito.consultado_por ? ` por ${credito.consultado_por}` : ''}
                {ok && credito.consulta_credito_id ? ` • nº ${credito.consulta_credito_id}` : ''}
                {ok && credito.contratos_existentes ? ` • ${credito.contratos_existentes} contrato(s) na Claro` : ''}
                {credito.notificado_em ? ` • BKO avisado (${credito.notificados || 0})` : ''}
              </p>
            )}
          </div>
        </div>
        {onReconsultar && (
          <button onClick={onReconsultar} disabled={carregando} className="inline-flex items-center gap-1 rounded-md border bg-white dark:bg-gray-900 px-2.5 py-1 text-xs font-medium hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-60" data-testid="credito-venda-reconsultar">
            {carregando ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} Reconsultar
          </button>
        )}
      </div>
    </div>
  );
};
